/**
 * Core: version + runtime settings shared by every genus module.
 */
// Bump on every meaningful change to the library.
export const VERSION = '0.19.0';

// HTML-escape a value for interpolation into markup (render callbacks etc.).
const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
export const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ESC[c]);

// Server-provided data the methods need at call time (API endpoints, tokens,
// user info, ...). Filled via g.init(), read anywhere as g.settings.<key>.
export const settings = {};

const isPlainObject = (v) => v && typeof v === 'object' && !Array.isArray(v);

// Deep-merge for plain objects (arrays and everything else are replaced), so
// calling init twice only overrides the keys it receives.
function merge(target, source) {
	for (const key of Object.keys(source)) {
		if (isPlainObject(source[key]) && isPlainObject(target[key])) merge(target[key], source[key]);
		else target[key] = source[key];
	}
}

// Call once per page (e.g. from an inline script with server data):
//   g.init({ api: { base: '/api', token: '...' } });
export function init(newSettings) {
	merge(settings, newSettings || {});
}
